import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { Modal, Form, Row, Col, message, InputNumber, Rate } from 'antd';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
};

const EditType = ({
    onClose,
    modalParams,
}) => {
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const onSubmit = () => {
        form.validateFields().then((values) => {
            let submitData = {
                id: modalParams.id,
                sortNo: values.sort,
                levelScore: values.levelScore,
                imgUrl: values.imgUrl[0].url,
            };
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderAppraiseService.updateStar', submitData, 'POST')
                .then(() => {
                    message.success('更新成功');
                    onClose(true);
                })
                .catch((err = {}) => {
                    message.error(err.message);
                    setConfirmLoading(false);
                });
        }).catch(() => { });
    };

    //上传事件
    const onFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    return <Modal
        title='评价类型'
        bodyStyle={{ paddingBottom: 0 }}
        centered
        destroyOnClose
        width={520}
        visible={true}
        confirmLoading={confirmLoading}
        onOk={onSubmit}
        onCancel={() => onClose(false)}
    >
        <Form
            id='editType'
            {...formLayout}
            autoComplete='off'
            name="create"
            scrollToFirstError
            initialValues={{
                sort: modalParams.sortNo,
                levelRate: modalParams.id,
                levelScore: modalParams.levelScore,
                imgUrl: modalParams.imgUrl ? generateFileList(modalParams.imgUrl) : []
            }}
            form={form}
        >

            <Row style={{ marginLeft: 105 }} align={'middle'}>
                <Col span={10}>
                    <Form.Item
                        name="levelRate"
                        colon={false}
                        rules={[
                            { required: false, },
                        ]}>
                        <Rate disabled />
                    </Form.Item>
                </Col>
                <Col style={{ marginBottom: 17 }} span={2}> {`${modalParams.id}星`}</Col>
            </Row>
            <Row>
                <Col span={22}>
                    <Form.Item
                        name="sort"
                        label="类型排序"
                        colon={false}
                        rules={[
                            { required: true, },
                            { type: 'number', min: 1, }
                        ]}>
                        <InputNumber
                            style={{ width: 150 }}
                            keyboard={true}
                            placeholder='请输入'
                            precision={0}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={22}>
                    <Form.Item
                        name="levelScore"
                        label="等级分值"
                        colon={false}
                        rules={[
                            { required: true, },
                            { type: 'number', max: 9999999 }
                        ]}>
                        <InputNumber
                            style={{ width: 150 }}
                            keyboard={true}
                            placeholder='请输入'
                            precision={0}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={22}>
                    <Form.Item
                        name="imgUrl"
                        label='类型图标'
                        colon={false}
                        valuePropName='fileList'
                        getValueFromEvent={onFile}
                        rules={[{ type: 'array', required: true, message: '上传类型图标' }]}
                    >
                        <CusotmUpload
                            accept='.png, .jpg, .jpeg, gif'
                            listType="picture-card"
                            wallMode='single'
                            removeError
                            qiniuUploadProps={{ uploadType: 'image' }}
                            beforeUpload={file => {
                                const isType = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'video/mp4'];
                                if (!isType.includes(file.type)) {
                                    message.warn('只能上传 .png, .jpg, .gif 格式的文件!');
                                    file.status = 'error';
                                    return false;
                                }
                            }}
                        >
                            <div style={{ color: '#999', fontSize: '12px' }}>添加图标</div>
                        </CusotmUpload>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    </Modal>;
};

EditType.propTypes = {
    onClose: PropTypes.func.isRequired,//关闭操作
    modalParams: PropTypes.object,
};

export default EditType;